'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconSquareX, iconSquareXTag } from '@ni/nimble-components/dist/esm/icons/square-x';
import { wrap } from '../../utilities/react-wrapper';

export type { IconSquareX };
export { iconSquareXTag };
export const NimbleIconSquareX = wrap(IconSquareX);